module.exports = __webpack_public_path__ + "img/REN.3649ab29.svg";